export default __webpack_public_path__ + "static/media/dbb1e9537af7ff289881c904551ab3e2.jpg";